import React, { Fragment } from 'react';
import classNames from 'classnames';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button, Link } from 'formlabs-web-components/Link';

import './SingleDatasheet.module.css';

const SingleDatasheet = ({
  datasheet,
  linkDisplay,
  linkText,
  fileLink,
  buttonColor,
  classes
}) => {
  const pdf = fileLink || datasheet;
  return (
    <Fragment>
      {linkDisplay === 'text' && (
        <Link to={pdf} target="_blank" classes={classes}>
          {linkText}
        </Link>
      )}
      {linkDisplay === 'button' && (
        <Button to={pdf} target="_blank" color={buttonColor} classes={classes}>
          {linkText}
        </Button>
      )}
      {linkDisplay === 'icon-underline-arrow' && (
        <Link
          to={pdf}
          target="_blank"
          styleName={classNames('icon-underline-arrow', buttonColor)}
          classes={classes}
        >
          <span styleName="linkText">{linkText}</span>
        </Link>
      )}
    </Fragment>
  );
};

export default DisplayComponent(SingleDatasheet);
